/**
 * GOFO/CIRRO E-Commerce injection hubs accepted by EasyPost's `ParcllAccount`
 * `origin_hub` credential. EasyPost does not validate the value server-side;
 * this list mirrors the select in the EasyPost dashboard.
 */
export const GOFO_ORIGIN_HUBS = [
  { code: "EA", label: "East (Atlanta)" },
  { code: "WE", label: "West (Los Angeles)" },
  { code: "CE", label: "Central (Chicago)" },
  { code: "NE", label: "Northeast (New York)" },
  { code: "SE", label: "Southeast (Miami)" },
  { code: "SO", label: "South (Dallas)" },
  { code: "NJ", label: "New Jersey" },
  { code: "SL", label: "Salt Lake City" },
  { code: "CA", label: "Canada" },
] as const;

export type GofoOriginHubCode = (typeof GOFO_ORIGIN_HUBS)[number]["code"];

export enum GofoByocaOriginHub {
  ATL = "ATL",
  CLT = "CLT",
  DEN = "DEN",
  DFW = "DFW",
  EWR = "EWR",
  IAH = "IAH",
  IND = "IND",
  JFK = "JFK",
  LAX = "LAX",
  MIA = "MIA",
  ORD = "ORD",
  PHX = "PHX",
  SEA = "SEA",
  SFO = "SFO",
  SLC = "SLC",
}

const GOFO_BYOCA_ORIGIN_HUB_LABELS: Record<GofoByocaOriginHub, string> = {
  [GofoByocaOriginHub.ATL]: "Atlanta",
  [GofoByocaOriginHub.CLT]: "Charlotte",
  [GofoByocaOriginHub.DEN]: "Denver",
  [GofoByocaOriginHub.DFW]: "Dallas / Fort Worth",
  [GofoByocaOriginHub.EWR]: "Newark",
  [GofoByocaOriginHub.IAH]: "Houston",
  [GofoByocaOriginHub.IND]: "Indianapolis",
  [GofoByocaOriginHub.JFK]: "New York City",
  [GofoByocaOriginHub.LAX]: "Los Angeles",
  [GofoByocaOriginHub.MIA]: "Miami",
  [GofoByocaOriginHub.ORD]: "Chicago",
  [GofoByocaOriginHub.PHX]: "Phoenix",
  [GofoByocaOriginHub.SEA]: "Seattle",
  [GofoByocaOriginHub.SFO]: "San Francisco",
  [GofoByocaOriginHub.SLC]: "Salt Lake City",
};

export const GOFO_BYOCA_ORIGIN_HUBS: readonly {
  code: GofoByocaOriginHub;
  label: string;
}[] = Object.values(GofoByocaOriginHub).map((code) => ({
  code,
  label: GOFO_BYOCA_ORIGIN_HUB_LABELS[code],
}));
